module.exports = __webpack_public_path__ + "img/headshot-jbeauzile.10df4dd2.png";